import type { MaybeRef } from "vue";
import { computed, toValue } from "vue";
import { useStore } from "vuex";
import type { TodoSubmission } from "@/components/MyStudentDetail/FilterableTodosSection/types";
import { hasMyStudentsToDosEnabled } from "@/composables/authorization.js";
import { useGetTodosSubmissions } from "@/providers/todosSubmissions/useGetTodosSubmissions";

export const useCurrentTodo = (todoId: MaybeRef<string>, applicationId: MaybeRef<string | undefined>) => {
  const store = useStore();
  const participantId = computed<string | undefined>(() => store.state.currentUser?.participantId ?? undefined);

  const { data, isLoading, refetch } = useGetTodosSubmissions(participantId, {
    enabled: computed<boolean>(
      () =>
        Boolean(hasMyStudentsToDosEnabled.value) && Boolean(participantId.value) && Boolean(toValue(applicationId)),
    ),
  });

  const todo = computed<TodoSubmission | undefined>(() =>
    (data.value ?? []).find(
      (item) => item.todo_id === toValue(todoId) && item.application_id === toValue(applicationId),
    ),
  );

  return { todo, isLoading, refetch };
};
